import React from 'react';
import PaymentRealizedReceived from 'components/Tvendo/Bank/DataMaster/Payments/PaymentRealizedReceived.js';

export default function () {
  return <PaymentRealizedReceived />;
}
